import { __assign } from "tslib";
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { rgbaArray2rgba } from '../../../utils/convertColours';
import Container from './Container';
import styles from './Layout.module.css';
var cx = classNames.bind(styles);
export default function Columns(_a) {
    var count = _a.count, offset = _a.offset, totalWidth = _a.totalWidth, columnWidth = _a.columnWidth, gutterWidth = _a.gutterWidth, isGutterOnOutside = _a.isGutterOnOutside, fillColor = _a.fillColor, strokeColor = _a.strokeColor;
    var left = offset;
    if (isGutterOnOutside) {
        left +=
            (totalWidth - (count * columnWidth + (count - 1) * gutterWidth)) / 2;
    }
    var columns = [];
    var colorStyle = fillColor
        ? { backgroundColor: rgbaArray2rgba(fillColor) }
        : { border: "1px solid ".concat(rgbaArray2rgba(strokeColor)) };
    for (var i = 0; i < count; i += 1) {
        columns.push(React.createElement("div", { className: cx('overlay', 'column'), key: i, style: __assign({ top: 0, left: left, width: columnWidth }, colorStyle) }));
        left += columnWidth + gutterWidth;
    }
    return React.createElement(Container, null, columns);
}
Columns.propTypes = {
    count: PropTypes.number.isRequired,
    offset: PropTypes.number.isRequired,
    columnWidth: PropTypes.number.isRequired,
    totalWidth: PropTypes.number.isRequired,
    gutterWidth: PropTypes.number.isRequired,
    isGutterOnOutside: PropTypes.bool.isRequired,
    fillColor: PropTypes.arrayOf(PropTypes.number),
    strokeColor: PropTypes.arrayOf(PropTypes.number),
};
